import React from 'react';
import 'react-dom';
import { Component } from '@gondel/core';
import { GondelReactComponent } from '@gondel/plugin-react';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

@Component('FavoritesTeaserRenderer')
export class FavoritesTeaserRenderer extends GondelReactComponent<FavoritesTeaserRenderer> {
	private FavoritesTeaser: any;
	private controllers: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation($(this._ctx));
	}

	public async start() {
		// tslint:disable-next-line
		this.FavoritesTeaser = ((await import(/* webpackChunkName: "dynamic-imports/favorites-teaser" */ './FavoritesTeaser')) as any).FavoritesTeaser;
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	/**
	 * This component is the bridge between gondel and react
	 * and does nothing less than rendering the favorite teaser
	 * via react.
	 */
	public render() {
		const FavoritesTeaser = this.FavoritesTeaser;
		return (
			<div className={`l-container__inner`}>
				<FavoritesTeaser {...this.state} />
			</div>
		);
	}
}
